interface AnalyticsEvent {
  event: string;
  timestamp: string;
  referrer: string;
  userAgent: string;
}

const STORAGE_KEY = 'pwm_analytics_events';

export function trackEvent(eventName: string): void {
  try {
    const event: AnalyticsEvent = {
      event: eventName,
      timestamp: new Date().toISOString(),
      referrer: document.referrer || 'direct',
      userAgent: navigator.userAgent,
    };

    const existingData = localStorage.getItem(STORAGE_KEY);
    const events: AnalyticsEvent[] = existingData ? JSON.parse(existingData) : [];
    events.push(event);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(events));
  } catch (error) {
    console.error('Analytics tracking error:', error);
  }
}

export function getAnalyticsEvents(): AnalyticsEvent[] {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error('Analytics retrieval error:', error);
    return [];
  }
}

export function clearAnalyticsEvents(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Analytics clear error:', error);
  }
}